"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScanCard = void 0;
var _react = _interopRequireDefault(require("react"));
var _ui = require("../../../../ui");
var _QRCode = require("./QRCode");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ScanCard = function ScanCard(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react.default.createElement(_ui.Card, null, /*#__PURE__*/_react.default.createElement(_ui.CardBody, null, /*#__PURE__*/_react.default.createElement(_QRCode.QRCode, {
    className: className
  })));
};
exports.ScanCard = ScanCard;